<template>
    <section class="l-section l-section--main o-start">
        <div class="l-container l-container--main l-container--horizontalPaddings">
            <div class="l-row l-row--center">
                <div class="l-row__column l-row__column--7">
                    <div class="l-row">
                        <div class="l-row__column l-row__column--8">
                            <h1 class="a-title">Podaj nam swój NIP</h1>
                            <p class="a-text">
                              Pozwoli nam to uzupełnić dane adresowe oraz dostępność naszych usług. Adres dostawy będziesz mógł zmienić w następnym kroku.
                            </p>
                        </div>
                    </div>
                    <form
                        @submit.prevent="handleSubmit"
                        class="a-mobile"
                    >
                        <div class="l-row l-row--verticalEnd">
                            <div class="l-row__column l-row__column--8">
                                <a-control
                                    label="Wpisz NIP"
                                    id="control-company"
                                    placeholder="1234567890"
                                    v-model="vatin"
                                />
                            </div>
                            <div class="l-row__column l-row__column--3 a-mobile__paddingless">
                                <div class="a-mobile__buttons">
                                    <a-button
                                        type="submit"
                                        class="a-button a-button--primary a-button--fullwidth"
                                        :is-processing="customerStatus === 'checkingVatin'"
                                    >
                                        Dalej
                                        <a-icon
                                            class="a-button__icon"
                                            icon="Right"
                                        />
                                    </a-button>
                                </div>
                            </div>
                        </div>
                        <div class="l-row l-row--verticalEnd">
                            <div class="l-row__column l-row__column--8 a-mobile__paddingless">
                                <o-notifications
                                    class="o-start__notification"
                                    :is-static="true"
                                    name="control-vatin"
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            vatin: ''
        }
    },
    metaInfo: {
        title: 'Owoce W Pracy B2B',
        titleTemplate: 'Owoce W Pracy B2B'
    },
    computed: {
        customerStatus() {
            return this.$store.getters.customerStatus
        }
    },
    methods: {
        handleSubmit() {
            if(typeof this.vatin !== 'string') {
                throw new Error('vatin is not a string')
            }
            this.vatin = this.vatin.replace(/-|\s/g, '')
            if(/^[0-9]{10}$/.test(this.vatin)) {
                // reset state
                this.$store.dispatch('resetState').then(() => {
                    this.$store.dispatch('retrieveAddressByVatin', this.vatin).then(() => {
                        this.$router.push({ name: 'delivery-address' })
                    }).catch(error => {
                        console.error(error)
                        this.$router.push({ name: 'delivery-address' })
                    })
                })
            } else {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wprowadzony numer jest nieprawidłowy!',
                    name: 'control-vatin'
                })
            }
        }
    }
}
</script>
